export const reverseGeocode = async (lat, lon) => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lon}`
    );
    console.log("lan lat cionver :: response",response);
    
    if (!response.ok) {
      throw new Error("Failed to fetch geocode");
    }

    const data = await response.json();
    const address = data.address;
    console.log("lan lat cionver :: response",data);
    // Extract suburb/area and city
    const area =
      address.suburb ||
      address.neighbourhood ||
      address.village ||
      address.town ||
      "";
    const city = address.city || address.county || address.state || "";

    // Combine area and city (e.g., "Kalewadi, Pune")
    const result = [area, city].filter(Boolean).join(", ");
    console.log("lan lat cionver :: result",result);
    
    return result || data.display_name || "Unknown Location";
  } catch (error) {
    console.error("Reverse geocoding error:", error);
    return "Unknown Location";
  }
};


